<template>
  <div>
    <search-tools @search="handleSearch">
      <search-select-field label="사업장명" v-model="nav.field" @input="handleSearch"/>
      <search-nav-item-select :label="$t('search.검색조건')" v-model="nav.searchType" :list="nav.searchTypes" style="align-self: center;"/>
      <search-nav-item-keyword :label="$t('search.키워드')" v-model="nav.keyword" @search="handleSearch" />
      <search-nav-item-select label="결재문서" v-model="nav.searchBoard" :list="searchBoards" style="align-self: center" :notSet="true" :searchOnChange="true" @search="handleSearch" />
    </search-tools>

    <div class="flex mb-4" style="justify-content: flex-end;">
      <vs-button v-if="selectedItems.length > 0"
                 color="danger"
                 class="mr-4"
                 @click="handleMultiDelete">
        선택한 {{ selectedItems.length }}건 삭제
      </vs-button>
      <vs-button v-else disabled>
        선택된 문서가 없습니다.
      </vs-button>
    </div>
    <vs-card >
      <vs-table
        stripe
        ref="table"
        :sst="true"
        :max-items="table.perPage"
        :data="isLoading ? [] : table.list"
        :noDataText="isLoading ? '' : $t('approval.결재문서가 없습니다')"
        @sort="handleSort"
        @selected="handleItemClickDetail">

        <template slot="thead">
          <vs-th>
            <div class="w-full text-center">
              <vs-checkbox v-model="selectAll" @click.stop @change="toggleSelectAll"></vs-checkbox>
            </div>
          </vs-th>
          <vs-th sort-key="id" style="min-width:80px;"><span class="w-full text-center">{{ $t('approval.No') }}</span></vs-th>
          <vs-th sort-key="content$body.stdInfo.field_name" style="min-width:130px;"><span class="w-full text-center">{{ $t('approval.사업장명') }}</span></vs-th>
          <vs-th sort-key="board_id" style="min-width:130px;"><span class="w-full text-center">{{ $t('approval.게시판') }}</span></vs-th>
          <vs-th sort-key="board_id" style="min-width:130px;"><span class="w-full text-center">{{ $t('approval.제목') }}</span></vs-th>
          <vs-th sort-key="status$name" style="min-width:130px;"><span class="w-full text-center">{{ $t('approval.상세') }}</span></vs-th>
          <vs-th sort-key="content$body.stdInfo.writer_name" style="min-width:130px;"><span class="w-full text-center">작성자</span></vs-th>
          <vs-th sort-key="content$body.stdInfo.section" style="min-width:130px;"><span class="w-full text-center">부서명</span></vs-th>
          <vs-th sort-key="updated_at" style="min-width:130px;"><span class="w-full text-center">{{ $t('approval.작성일') }}</span></vs-th>
        </template>

        <template slot-scope="{data}">
          <!-- 로딩 중일 때 표시할 내용 -->
          <vs-tr v-if="isLoading">
            <vs-td colspan="100" class="text-center">
              <div class="w-full p-5 flex items-center justify-center" style="min-height: 100px">
                <vs-icon icon="loop" class="mr-2 animate-spin"></vs-icon>
                <span>데이터를 불러오는 중입니다...</span>
              </div>
            </vs-td>
          </vs-tr>
          <!-- 데이터가 있을 때 표시할 내용 -->
          <template v-else>
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td class="text-center" @click.stop>
                <vs-checkbox :value="isItemSelected(tr)" @click.stop @change="handleItemSelect(tr)"></vs-checkbox>
              </vs-td>
              <vs-td class="text-center">{{ getNo(indextr) }}</vs-td>
              <vs-td class="text-center">{{ (tr.post && tr.post.field) ? tr.post.field.field_name : '' }}</vs-td>
              <vs-td class="text-center">{{ getBoardTitle(tr) }}</vs-td>
              <vs-td class="text-center">{{ getPostTitle(tr) }}</vs-td>
              <vs-td class="text-center">{{ tr.document_status && tr.document_status.name }}</vs-td>
              <vs-td class="text-center">{{ tr.post.author && tr.post.author.name }}</vs-td>
              <vs-td class="text-center">{{ tr.post.author && (tr.post.author.section || tr.post.author.company.com_name ) || '-' }}</vs-td>
              <vs-td class="text-center">{{ (tr.post) ? getDate(tr.post.updated_at) : ''}}</vs-td>
            </vs-tr>
          </template>
        </template>
      </vs-table>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination
            :total="(lastPage) ? lastPage : 1"
            v-model="currentPage" @change="handleChangePage"></k-pagination>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import SearchNav from '@/components/nav/SearchNav'
import SearchNavItemDate from '@/components/nav/SearchNavItemDate'
import SearchNavItemKeyword from '@/components/nav/SearchNavItemKeyword'
import SearchNavItemSelect from '@/components/nav/SearchNavItemSelect'
import KPagination from '@/components/kPagination/kPagination'
import SearchNavItemProject from '@/components/nav/SearchNavItemProject'
import SearchSelectField from "@/views/list/components/SearchSelectField.vue";
import SearchTools from "@/views/list/components/SearchTools.vue";
import FilterBoardIds from "./FilterBoardIds.js";
import getPostTitleFn from "./getPostTitle.js";
import DateUtil from "../../util/DateUtil";
import searchKeywordCondition from "./searchKeywordCondition.js";

export default {
  name: 'ApprovalRequest',
  components: {
    SearchTools,
    SearchSelectField,
    SearchNavItemProject,
    KPagination,
    SearchNavItemSelect,
    SearchNavItemKeyword,
    SearchNavItemDate,
    SearchNav
  },
  computed: {
    DateUtil() {
      return DateUtil
    },
    searchBoards() {
      return [{ value: 0, text: "전체" }, ...FilterBoardIds(this.$store.state.menu.availableBoardIds)];
    },
    projectId () {
      return this.$route.params.proj_id
    },
    rootPath () {
      const paths = this.$route.path.split('/')
      return `/${paths[1]}/${paths[2]}/${paths[3]}`
    },
    memberId() {
      return this.$store.state.member.memberInfo.id
    }
  },
  data () {
    return {
      // 로딩 상태 추가
      isLoading: false,
      // 검색 네비게이션
      nav: {
        projectId:'',
        field: {
          fieldName: '',
          fieldId: ''
        },
        date: ['', ''],
        keyword: '',
        type: '',
        typeList: [],
        orderTarget:'created_at',
        orderDirection:'desc',
        searchTypes: [
          {text:'부서명', value:'body.stdInfo.section'},
          // {text:'작성자명', value:'author.name'},
          {text:'문서명', value:'post_title'},
        ],
        searchType: '',
        searchBoard: 0,
      },

      currentPage: 1,
      lastPage: 1,
      total: 0,
      table: {
        list: [],
        perPage: 10,
        keyword: ''
      },
      // 체크박스 관련 데이터
      selectAll: false,
      selectedItems: [],
    }
  },
  created () {
    this.loadPostList()
  },

  methods: {
    getNo (index) {
      return this.total - (((this.currentPage - 1) * this.table.perPage) + index)
    },

    async loadMember() {
      await this.$store.dispatch("member/LOAD_MEMBER_DETAIL");
    },

    async loadPostList () {
      try {
        // 로딩 상태 활성화
        this.isLoading = true
        // 테이블 초기화
        this.table.list = []
        // 선택 항목 초기화
        this.selectedItems = []
        this.selectAll = false

        if (this.memberId === undefined) {
          await this.loadMember()
        }

        const projectId = this.projectId //this.nav.projectId
        let boardSlug = ''
        if (this.nav.searchBoard && this.nav.searchBoard !== 0) {
          boardSlug = `board-${this.nav.searchBoard}`
        }
        const page = this.currentPage
        const perPage = this.table.perPage
        const keyword = []
        const orderTarget = this.nav.orderDirection ? this.nav.orderTarget : '$updated_at'
        const orderDirection = this.nav.orderDirection
        const statusIds = [1];
        const conditions = []
        if (this.nav.field.fieldId) {
          conditions.push({key: 'body.stdInfo.field_id', operator: '=', value: this.nav.field.fieldId})
        }
        if (this.nav.searchType && !!this.nav.keyword) {
          conditions.push(searchKeywordCondition(this.nav.searchType, this.nav.keyword))
        }

        // 임시저장 문서는 사용자가 작성한 문서만 조회되도록 해야 한다
        conditions.push({
          key: 'author.id', operator: '=', value: this.memberId
        })

        await this.$store.dispatch('approval/LOAD_POST_ALL', {
          page,
          perPage,
          boardSlug,
          projectId,
          keyword,
          orderTarget,
          orderDirection,
          conditions,
          statusIds,
        })
        this.table.list = this.$store.state.approval.list

        const listInfo = this.$store.state.approval.postListInfo
        this.currentPage = listInfo.current_page
        this.lastPage = listInfo.last_page
        this.total = listInfo.total
      } finally {
        // 로딩 상태 비활성화
        this.isLoading = false
      }
    },

    handleSearch () {
      this.currentPage = 1
      this.loadPostList()
    },

    getBoardTitle (data) {
      if (data.post) {
        if (data.post.board) {
          return data.post.board.board_title
        }
      }
      return ''
    },

    getPostTitle (data) {
      return getPostTitleFn(data)
    },

    getDate (date) {
      return new Date(date).format('yyyy-MM-dd')
    },

    movePost (projectId, boardId, postId) {

      /* 안전·보건예산 현황 */
      if (boardId === 3) { this.$router.push({path: `/project/${projectId}/write/report/project_monthly_report/${postId}`}); return }
      /* 최초 위험성평가 */
      if (boardId === 6) { this.$router.push({path: `/project/${projectId}/risk/assessment/first/${postId}`}); return }
      /* 정기위험성평가 */
      if (boardId === 7) { this.$router.push({path: `/project/${projectId}/risk/assessment/regular/${postId}`}); return }
      /* 수시위험성평가 */
      if (boardId === 41) { this.$router.push({path: `/project/${projectId}/risk/assessment/always/${postId}`}); return }
      /* 위험성평가협의회 */
      if (boardId === 8) { this.$router.push({path: `/project/${projectId}/risk/conference/warning/${postId}`}); return }
      /* 수시 위험성평가협의회 */
      if (boardId === 42) { this.$router.push({path: `/project/${projectId}/risk/conference/warning-always/${postId}`}); return }
      /* 산업안전보건위원회 */
      if (boardId === 9) { this.$router.push({path: `/project/${projectId}/risk/conference/safety/${postId}`}); return }
      /* 작업허가서(내부용) */
      if (boardId === 10) { this.$router.push({path: `/project/${projectId}/risk/permit/work/${postId}`}); return }
      /* 작업허가서(외부용) */
      if (boardId === 11) { this.$router.push({path: `/project/${projectId}/risk/permit/work_export/${postId}`}); return }

      /* 안전점검일지 */
      if (boardId === 13) { this.$router.push({path: `/project/${projectId}/risk/check/checklog/${postId}`}); return }
      /* 안전점검일지 */
      if (boardId === 14) { this.$router.push({path: `/project/${projectId}/risk/check/checklogall/${postId}`}); return }
      /* 산업재해무재해 */
      if (boardId === 22) { this.$router.push({path: `/project/${projectId}/safety/accident/report/${postId}`}); return }
      /* 안전용품 현황 */
      if (boardId === 23) { this.$router.push({path: `/project/${projectId}/safety/supplies/${postId}`}); return }
      /* 건설장비관리 */
      if (boardId === 24) { this.$router.push({path: `/project/${projectId}/safety/equipment/plan/${postId}`}); return }
      /* 환경일일점검 */
      if (boardId === 28) { this.$router.push({path: `/project/${projectId}/state/check/daily/${postId}`}); return }
      /* 환경월간점검 */
      if (boardId === 29) { this.$router.push({path: `/project/${projectId}/state/check/monthly/${postId}`}); return }
      /* 환경지원 */
      if (boardId === 30) { this.$router.push({path: `/project/${projectId}/state/support/${postId}`}); return }
      /* 환경평가 */
      if (boardId === 31) { this.$router.push({path: `/project/${projectId}/state/evaluation/${postId}`}); return }
      /* 환경이슈보고 */
      if (boardId === 32) { this.$router.push({path: `/project/${projectId}/state/report/issue/${postId}`}); return }
      /* 환경사고보고 */
      if (boardId === 33) { this.$router.push({path: `/project/${projectId}/state/report/accident/${postId}`}); return }

      /* HSE 교육관리 */
      if (boardId === 35) { this.$router.push({path: `/project/${projectId}/hse/list/safety/${postId}`}); return }
      /* 안전요청 */
      if (boardId === 36) { this.$router.push({path: `/project/${projectId}/prevention/request/safety/${postId}`}); return }
      /* 환경요청 */
      if (boardId === 39) { this.$router.push({path: `/project/${projectId}/prevention/request/environment/${postId}`}); return }
      /* 보건요청 */
      if (boardId === 40) { this.$router.push({path: `/project/${projectId}/prevention/request/health/${postId}`}); return }

      /* 사고보고 */
      if (boardId === 45) { this.$router.push({path: `/project/${projectId}/write/accident/accident_report/${postId}`}); return }
      /* 산재검토 */
      if (boardId === 46) { this.$router.push({path: `/project/${projectId}/write/accident/accident_review/${postId}`}); return }

      /* 444점검 */
      if (boardId === 48) { this.$router.push({path: `/project/${projectId}/write/safety_check/safety_check_444/${postId}`}); return }
      /* 출역장비 */
      if (boardId === 49) { this.$router.push({path: `/project/${projectId}/write/safety_check/safety_check_444/${postId}`}); return }
      /* 파트너사 계약현황 */
      if (boardId === 50) { this.$router.push({path: `/project/${projectId}/plan/partners`}); return }
      /* 444점검 */
      if (boardId === 51) { this.$router.push({path: `/project/${projectId}/write/safety_check_partner/safety_check_partner_444/${postId}`}); return }

      /* 사고조사 보고서 */
      if (boardId === 53) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 사고경위서 */
      if (boardId === 54) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 목격자 진술서 */
      if (boardId === 55) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 실험실 안전사고 보고 */
      if (boardId === 56) { this.$router.push({path: `/project/${projectId}/approval/${boardId}/write/${postId}`}); return }
      /* 산업재해조사표 */
      if (boardId === 57) { this.$router.push({path: `/project/${projectId}/normal/${boardId}/write/${postId}`}); return }
      /* 산업안전보건위원회 */
      if (boardId === 58) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전경영위원회 */
      if (boardId === 59) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전근로협의체 */
      if (boardId === 60) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전보건협의체 */
      if (boardId === 61) { this.$router.push({path: `/project/${projectId}/normal/${boardId}/write/${postId}`}); return }
      /* 아차사고 사례 카드 */
      if (boardId === 62) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 아차사고 사례 개선 확인 카드 */
      if (boardId === 63) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 실험실 일상 점검표 */
      if (boardId === 64) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 실험실 정기 점검표 */
      if (boardId === 65) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* TAC 안전관리 점검표 */
      if (boardId === 66) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 밀폐공간 작업프로그램 평가표 */
      if (boardId === 67) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 밀폐공간 작업 전 체크리스트 */
      if (boardId === 68) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 고압가스 충전실 안전점검표 */
      if (boardId === 69) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 한수단 2호 안전점검표 */
      if (boardId === 70) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 잠수 운용 계획서 */
      if (boardId === 71) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 잠수작업 전 안전점검표 */
      if (boardId === 72) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 잠수 운용 결과서 */
      if (boardId === 73) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 중량물·운반기계 안전점검표 */
      if (boardId === 74) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업장 안전점검표 */
      if (boardId === 75) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 부적합 및 시정조치 - 안전 */
      if (boardId === 76) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 부적합 및 시정조치 - 보건 */
      if (boardId === 77) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업중지보고서 - 임직원 */
      if (boardId === 78) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업중지보고서 - 근로자 */
      if (boardId === 79) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업중지 조치결과서 - 임직원 */
      if (boardId === 80) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업중지 조치결과서 - 근로자 */
      if (boardId === 81) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 정기 위험성 평가 */
      if (boardId === 82) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 수시 위험성 평가 */
      if (boardId === 83) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전작업허가 - 작업수행부서 */
      if (boardId === 84) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전작업허가 - 수급업체 */
      if (boardId === 85) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 안전·보건예산 현황 */
      if (boardId === 86) { this.$router.push({path: `/project/${projectId}/approval/${boardId}/write/${postId}`}); return }
      /* 작업중지보고서 - 기타 */
      if (boardId === 87) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }
      /* 작업중지 조치결과서 - 기타 */
      if (boardId === 88) { this.$router.push({path: `/project/${projectId}/tab/${boardId}/write/${postId}`}); return }

      // BS
      if (boardId >= 100) {
        const popup = window.open(`/project/${projectId}/tab/${boardId}/write/${postId}?_c_back=t`, '_blank', `width=${  screen.width  },height=${  screen.height}`);

        // 팝업이 닫혔는지 감지하는 함수
        const checkPopupClosed = setInterval(() => {
          if (popup && popup.closed) {
            clearInterval(checkPopupClosed);
            // 페이지를 새로고침하지 않고 목록만 갱신
            this.loadPostList();
            // 목록이 갱신되었다는 알림 표시
            this.$vs.notify({
              title: '알림',
              text: '게시글 목록이 갱신되었습니다.',
              color: 'success',
              position: 'top-right'
            });
          }
        }, 500); // 0.5초마다 확인
      }


    },

    handleChangePage (page) {
      this.currentPage = page
      this.loadPostList()
    },

    handleItemClickDetail (data) {
      // 체크박스를 클릭한 경우 상세 페이지로 이동하지 않음
      if (event && event.target && (event.target.type === 'checkbox' || event.target.closest('.vs-checkbox'))) {
        return
      }

      const projectId = data.post.project_id
      const boardId = data.post.board_id
      const postId = data.post.id
      this.movePost(projectId, boardId, postId)
    },
    handleClickRegister () {

    },

    handleSort (key, type) {
      if (key) {
        this.nav.orderTarget = key
        this.nav.orderDirection = type

        this.loadPostList()
      }
    },

    // 전체 선택 토글 함수
    toggleSelectAll() {
      if (this.selectAll) {
        this.selectedItems = this.table.list.map(item => item.id)
      } else {
        this.selectedItems = []
      }
    },

    // 개별 항목 선택 처리 함수
    handleItemSelect(item) {
      const index = this.selectedItems.findIndex(i => i === item.id)
      if (index === -1) {
        this.selectedItems.push(item.id)
      } else {
        this.selectedItems.splice(index, 1)
        this.selectAll = false
      }
    },

    // 항목이 선택되었는지 확인하는 함수
    isItemSelected(item) {
      return this.selectedItems.includes(item.id)
    },

    // 다중 삭제 처리 함수
    async handleMultiDelete() {
      if (this.selectedItems.length === 0) {
        this.$vs.notify({
          title: '알림',
          text: '선택된 문서가 없습니다.',
          color: 'warning'
        })
        return
      }

      // 사용자 확인
      this.$vs.dialog({
        type: 'confirm',
        title: '문서 삭제',
        text: `선택한 ${this.selectedItems.length}건의 임시저장 문서를 삭제하시겠습니까?\n삭제된 문서는 복구할 수 없습니다.`,
        acceptText: '예',
        cancelText: '아니오',
        accept: async () => {
          try {
            // 로딩 다이얼로그 표시
            const event = new CustomEvent('loadingDialog', {
              detail: {
                open: true,
                num: 0,
                total: this.selectedItems.length,
                unit: '건'
              }
            })
            window.dispatchEvent(event)

            // 순차적으로 삭제 처리
            let successCount = 0
            let errorCount = 0
            const errors = []

            for (let i = 0; i < this.selectedItems.length; i++) {
              const itemId = this.selectedItems[i]
              const item = this.table.list.find(item => item.id === itemId)

              if (!item || !item.post) {
                errorCount++
                continue
              }

              // 로딩 다이얼로그 업데이트
              const updateEvent = new CustomEvent('loadingDialog', {
                detail: {
                  open: true,
                  num: i + 1,
                  total: this.selectedItems.length,
                  unit: '건'
                }
              })
              window.dispatchEvent(updateEvent)

              try {
                // boardSlug 추출 (post.board.board_slug 또는 board_id 기반으로)
                const boardSlug = item.post.board ? item.post.board.board_slug : `board_${item.post.board_id}`

                // 삭제 처리
                await this.$store.dispatch('approval/DELETE_POST', {
                  boardSlug,
                  postId: item.post.id,
                })
                successCount++
              } catch (error) {
                console.error(`문서 삭제 오류 (ID: ${item.post.id}):`, error)
                errors.push({
                  id: item.post.id,
                  error: error.message || error
                })
                errorCount++
              }

              // 약간의 딜레이 추가 (서버 부하 방지)
              await new Promise(resolve => setTimeout(resolve, 300))
            }

            // 로딩 다이얼로그 닫기
            const closeEvent = new CustomEvent('loadingDialog', {
              detail: {
                open: false
              }
            })
            window.dispatchEvent(closeEvent)

            // 결과 알림
            if (errorCount === 0) {
              this.$vs.notify({
                title: '완료',
                text: `${successCount}건의 문서가 삭제되었습니다.`,
                color: 'success'
              })
            } else {
              this.$vs.notify({
                title: '부분 완료',
                text: `${successCount}건 삭제 완료, ${errorCount}건 삭제 실패`,
                color: 'warning'
              })
            }

            // 목록 갱신 및 선택 초기화
            this.selectedItems = []
            this.selectAll = false
            this.loadPostList()
          } catch (error) {
            // 오류 처리
            const closeEvent = new CustomEvent('loadingDialog', {
              detail: {
                open: false
              }
            })
            window.dispatchEvent(closeEvent)

            this.$vs.notify({
              title: '오류',
              text: `삭제 처리 중 오류가 발생했습니다: ${error.message || error}`,
              color: 'danger'
            })
          }
        }
      })
    },
  }
}
</script>

<style scoped>
.animate-spin {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
